"use client"

import { Button } from '@yeshuman/sdk'
import { Search, RefreshCw, ChartNoAxesColumn } from 'lucide-react'

export interface SearchButtonsProps {
  onQuickSearch: () => void
  onSmartSearch: () => void
  isQuickSearching: boolean
  isSmartSearching: boolean
  disabled?: boolean
  showQuickSearch?: boolean
}

export function SearchButtons({
  onQuickSearch,
  onSmartSearch,
  isQuickSearching,
  isSmartSearching,
  disabled = false,
  showQuickSearch = true,
}: SearchButtonsProps) {
  return (
    <div className="flex gap-2">
      {showQuickSearch ? (
        <Button
          type="button"
          onClick={(e) => {
            e.preventDefault()
            e.stopPropagation()
            onQuickSearch()
          }}
          disabled={disabled || isQuickSearching || isSmartSearching}
          variant="outline"
          className="flex-1"
        >
          {isQuickSearching ? (
            <>
              <Search className="size-4 mr-2 animate-spin" />
              Quick Searching...
            </>
          ) : (
            <>
              <Search className="size-4 mr-2" />
              Quick Search
            </>
          )}
        </Button>
      ) : null}
      <Button
        type="button"
        onClick={(e) => {
          e.preventDefault()
          e.stopPropagation()
          onSmartSearch()
        }}
        disabled={disabled || isQuickSearching || isSmartSearching}
        className="flex-1"
      >
        {isSmartSearching ? (
          <>
            <RefreshCw className="animate-spin" aria-hidden />
            Analysing...
          </>
        ) : (
          <>
            <ChartNoAxesColumn aria-hidden />
            Analysis
          </>
        )}
      </Button>
    </div>
  )
}
